import { useFeatureFlagValue } from "@mirage/service-experimentation/useFeatureFlagValue";
import { MultimediaView } from "@mirage/shared/search/search-result";

import type { SearchFilter } from "@mirage/shared/search/search-filters";
import { isInsideExtensionSidePanel } from "@mirage/shared/util/webExtensionsHelpers";

export const useMultimediaView = (filters: SearchFilter[]): MultimediaView => {
  //app.dropboxexperiment.com/features/dash_2025_03_13_multimedia_search
  // OFF = Regular filter search view
  // ON = Media flow view through Search API
  // V1 = Media flow view through Search API
  const shouldFetchMultimediaResults = useFeatureFlagValue(
    "dash_2025_03_13_multimedia_search",
  );
  if (shouldFetchMultimediaResults === "OFF" || isInsideExtensionSidePanel()) {
    return MultimediaView.OFF;
  }
  if (
    filters.find((filter) => filter.id === "image" || filter.id === "video")
  ) {
    if (shouldFetchMultimediaResults === "V1") {
      return MultimediaView.V1;
    }
    if (shouldFetchMultimediaResults === "ON") {
      return MultimediaView.ON;
    }
  }
  return MultimediaView.OFF;
};
